module.exports = __webpack_public_path__ + "static/media/title_glimpse.50de2e21.svg";